import React, { useEffect, useState } from 'react';
import { Button, Input, Table } from 'reactstrap';
import { FiArrowDownCircle, FiArrowUpCircle } from 'react-icons/fi';
import { Controller } from 'react-hook-form';
import { EntityStageConfigModal } from '../../../../shared/components/EntityStageRuleConfig/EntityStageConfigModal';

export const LeadStagesConfig = ({
  control,
  register,
  setValue,
  watch,
  leadStages = [],
  selectedLeadStages = [],
  defaultStageId,
  lostStageId,
  conversionStageId,
  leadStagesConfig,
  setLeadStagesConfig,
  customFields = [],
  processId,
  leadStageRules,
  getInfo
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [specificLeadStage, setSpecificLeadStage] = useState({});

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  useEffect(() => {
    register('isDefault');
    register('isConversion');
    register('isLost');

    if (defaultStageId) setValue('isDefault', `${defaultStageId}`);
    if (conversionStageId) setValue('isConversion', `${conversionStageId}`);
    if (lostStageId) setValue('isLost', `${lostStageId}`);
  }, [register, defaultStageId, conversionStageId, lostStageId, setValue]);

  useEffect(() => {
    if (leadStages && leadStages.length > 0) {
      const config = [];
      for (const stgId of selectedLeadStages) {
        let info = leadStages.find((stg) => stg.id === stgId);
        if (info) {
          config.push(info);
        }
      }
      setLeadStagesConfig(config);
    }
  }, [selectedLeadStages, leadStages, setLeadStagesConfig]);

  if (
    !leadStages ||
    !leadStages.length ||
    !selectedLeadStages ||
    !selectedLeadStages.length
  ) {
    return null;
  }

  const switchItems = (index1, index2) => {
    [leadStagesConfig[index1], leadStagesConfig[index2]] = [
      leadStagesConfig[index2],
      leadStagesConfig[index1]
    ];
    setLeadStagesConfig([...leadStagesConfig]);
  };

  const upItem = (i) => {
    const index = leadStagesConfig.indexOf(i);
    if (index > 0) {
      switchItems(index, index - 1);
    }
  };

  const downItem = (i) => {
    const index = leadStagesConfig.indexOf(i);
    if (index < leadStagesConfig.length - 1) {
      switchItems(index, index + 1);
    }
  };

  return (
    <div>
      <Table bordered={true} striped={true} size="sm" className="text-center">
        <thead>
          <tr>
            <th>Fase</th>
            <th>Editar</th>
            <th>Padrão</th>
            <th>Conversão</th>
            <th>Perdido</th>
            <th>Ordenar</th>
            <th>Ativar</th>
          </tr>
        </thead>
        <tbody>
          {leadStagesConfig?.length &&
            leadStagesConfig.map((stage, index) => {
              const stageRule = leadStageRules.find(
                (info) => info?.leadStageId === stage?.id
              );
              const info = {
                ...stage,
                index
              };
              if (!stage?.StageSettings && stageRule?.stageSettings) {
                info.StageSettings = stageRule.stageSettings;
              }

              return (
                <tr key={stage.id}>
                  <td className="text-left">{stage.name}</td>
                  <td>
                    <Button
                      size="sm"
                      color="info"
                      onClick={() => {
                        setSpecificLeadStage(info);
                        toggleModal();
                      }}
                    >
                      <li className="fas fa-user-edit"></li>
                    </Button>
                  </td>
                  <td>
                    <label htmlFor={stage.id}>
                      <input
                        name="isDefault"
                        type="radio"
                        value={stage.id}
                        id={stage.id}
                        checked={Number(watch('isDefault')) == Number(stage.id)}
                        onChange={(event) =>
                          setValue('isDefault', event.target.value)
                        }
                      />
                    </label>
                  </td>
                  <td>
                    <label htmlFor={stage.id}>
                      <input
                        name="isConversion"
                        type="radio"
                        value={stage.id}
                        id={stage.id}
                        checked={
                          Number(watch('isConversion')) === Number(stage.id)
                        }
                        onChange={(event) =>
                          setValue('isConversion', event.target.value)
                        }
                      />
                    </label>
                  </td>
                  <td>
                    <label htmlFor={stage.id}>
                      <input
                        name="isLost"
                        type="radio"
                        value={stage.id}
                        id={stage.id}
                        checked={Number(watch('isLost')) === Number(stage.id)}
                        onChange={(event) =>
                          setValue('isLost', event.target.value)
                        }
                      />
                    </label>
                  </td>
                  <td>
                    <div className="">
                      <FiArrowUpCircle
                        size={20}
                        cursor="pointer"
                        onClick={() => upItem(stage)}
                      />
                      <FiArrowDownCircle
                        style={{ marginLeft: '10px' }}
                        size={20}
                        cursor="pointer"
                        onClick={() => downItem(stage)}
                      />
                    </div>
                  </td>
                  <td>
                    <Controller
                      name={`${stage.id}-isActive`}
                      control={control}
                      render={(props) => (
                        <>
                          <label className="form-control-label">
                            <Input
                              type="checkbox"
                              onChange={(e) => props.onChange(e.target.checked)}
                              checked={props.value}
                              disabled={true}
                            />
                          </label>
                        </>
                      )}
                      defaultValue={true}
                    />
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
      {isModalOpen && (
        <EntityStageConfigModal
          isModalOpen={isModalOpen}
          toggleModal={toggleModal}
          entityInfo={
            specificLeadStage && specificLeadStage.id ? specificLeadStage : {}
          }
          customFields={customFields}
          callBack={() => {
            getInfo();
          }}
          processId={processId}
          entity={'LEAD'}
        />
      )}
    </div>
  );
};
